/* Const,Let & Var will be here */
export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_ERROR = 'LOGIN_ERROR';
export const LOGOUT = 'Logout';

/* Const,Let & Var will be here */
export function login(isLoginSuccess, employeeNumber, employeeId, deviceId,deviceEmpID, empFullName, accessToken) {
    if (isLoginSuccess) {
        return {
            type: LOGIN_SUCCESS,
            loggedIn: isLoginSuccess,
            employeeNumber: employeeNumber,
            employeeId: employeeId,
            deviceId: deviceId,
            deviceEmpID:deviceEmpID,
            empFullName: empFullName,
            accessToken: accessToken
        };
    } else {
        return {
            type: LOGIN_ERROR
        };
    }
}

export function logout() {
    return {
        type: LOGOUT
    };
}